
import { useState } from "react";
import BSModal from "./widgets/BSModal";

export const HelpButtonModal = ({title, modal_html}) => {
	const [modal_display_bool, setModalDisplay] = useState(false);
	const handleModalShow = (event) => {
		setModalDisplay(true);
	};


	const modal_props_js = { modal_display_bool, setModalDisplay, modal_html };

	return (
		<>
			<button
				className="btn btn-link"
				data-whatever={modal_html}
				onClick={handleModalShow}
			>
				{title}
			</button>
			<BSModal {...modal_props_js} />
		</>
	);
};

